import GlobalBreadcrumbsMixin from "../../../shared/Mixins/GlobalBreadcrumbsMixin";
import ComponentMixin from "../../../shared/Mixins/ComponentMixin";
import SetupStore from "@shared/components/Setup/SetupStore";

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  data () {
    return {
      formPage: true,
      resourceName: "voucher_template"
    };
  },

  mounted () {
    this.setBreadcrumb("Templates");
  },

  methods: {
    navigateToNewRoute () {
      this.$router.push({
        path: SetupStore.setupStages[3]()
      });
    },

    navigateToIndexRoute () {
      this.$router.push({
        path: "/templates"
      });
    }
  }
};
